import { getIn } from 'seamless-immutable';

export const formatData = (data: any) => {
  const answerData = getIn(data, ['answers', 0], { answer: '', createdAt: '' });
  const ownerQuestion = getIn(data, ['owner'], { id: '', name: '' });

  const answer = {
    createdAt: new Date(answerData?.createdAt).toLocaleDateString('pt-BR'),
    text: answerData?.answer,
    owner: answerData?.owner?.name,
    id: answerData?.id,
  };
  const customerQuestionData = {
    answer: answer,
    owner: ownerQuestion,
    evaluation: {
      like: answerData?.evaluation?.likes,
      dislike: answerData?.evaluation?.likes,
      rating: answerData?.evaluation?.rating,
    },
    createdAt: answer?.createdAt,
    id: data?.id,
    question: data?.question,
  };

  return customerQuestionData;
};
